import { useRobotManufacturerContext } from '../../../../pages/machine/robot-manufacturer-context';
import { hasBeaconEngineSupport } from '../../../../robot/robot.utils';

/**
 * Returns whether step mode is available for the current robot.
 * BeaconEngine robots do not support step mode.
 */
export function useHasStepMode(): boolean {
  const manufacturerContext = useRobotManufacturerContext();
  const isBeaconEngine = hasBeaconEngineSupport(manufacturerContext);

  return !isBeaconEngine;
}
